import { styled } from 'baseui'

export const SDInputOverrides = error => ({
  Root: {
    style: () => ({
      borderColor: error ? `#B30F16` : '',
      backgroundColor: error ? 'transparent' : '',
      paddingRight: 0,
    }),
  },
  Input: {
    style: $disabled => ({
      color: 'black',
      paddingRight: '.75rem',
      paddingLeft: '.45rem',
      paddingBottom: '.125rem',
      borderColor: error ? '#B30F16' : '',
      backgroundColor: error || $disabled ? 'transparent' : '',
    }),
  },
  InputContainer: {
    style: {
      paddingTop: '0.625rem',
      backgroundColor: error ? 'transparent' : '',
    },
  },
  EndEnhancer: {
    style: () => ({
      paddingLeft: '2px',
      paddingRight: '1px',
      paddingBottom: '1px',
      paddingTop: '1px',
      backgroundColor: error ? 'transparent' : '',
    }),
  },
})

export const FloatingLabel = styled('div', () => ({
  position: 'absolute',
  top: '0.375rem',
  left: '0.5rem',
  height: '1rem',
  fontSize: '0.75rem',
  color: 'gray',
  display: 'flex',
  alignItems: 'center',
  pointerEvents: 'none',
  backgroundColor: 'transparent',
}))
